/**
 * Bundle.js - Scripts principais da aplicação
 * Carregado apenas em páginas autenticadas
 */

// Funcionalidades compartilhadas
import "./shared/core.js";
import "./shared/components/index.js";
import "./modules/shared/masks-validator.js";
import { setLoadingState } from "./utils/common.js";

// Módulos organizados
import { modalPassSuccess, initUIInteractions } from "./modules/ui/interactions.js";
import "./modules/ui/sidebar.js";
import {
    loadServicesData,
    initServiceSelect,
    initServicesModule,
} from "./modules/services/index.js";
import "./modules/serviceorders/index.js";
import {
    calculaDesconto,
    calculaDescontoPorValor,
} from "./modules/serviceorders/discounts.js";
import { initListingsModule } from "./modules/listings/index.js";
import { initFormsModule } from "./modules/forms/index.js";
import { initDashboardModule } from "./modules/dashboard/index.js";
import "./modules/vehicles/index.js";
import "./modules/vehicles/create.js";
import "./modules/client/index.js";
import "./modules/employee/index.js";
import "./modules/suppliers/index.js";
import "./modules/stock/index.js";
import { obterMarcas } from "./modules/client/vehicle.js";
import ApexCharts from "apexcharts";
window.ApexCharts = ApexCharts;
import { renderBarChart } from "./shared/components/barChart.js";

// Popper
import * as Popper from '@popperjs/core';
window.Popper = Popper;

// Swiper
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// Lottie
import { DotLottie } from '@lottiefiles/dotlottie-web';

document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.querySelector('#dotlottie-canvas');

    if (canvas) {
        new DotLottie({
            autoplay: true,
            loop: false,
            canvas: canvas,
            src: '/images/success-animation.lottie',
        });
    }
});

// Utilitários
import { aplicarMascaras } from "./utils/common.js";
import { initFormGuard } from "./utils/form-guard.js";

// jQuery e plugins
window.$ = window.jQuery = require("jquery");
require("jquery-mask-plugin");

// Chart.js já está disponível globalmente via core.js
// Chart.js disponível no bundle.js

// Inicialização principal
$(document).ready(function () {
    // Inicializa todos os módulos
    initUIInteractions();
    initServicesModule();
    initListingsModule();
    initFormsModule();
    initDashboardModule();

    // Inicializa o Form Guard
    initFormGuard();

    // Aplica máscaras gerais
    aplicarMascaras();
});

// Inicialização de gráficos do dashboard
document.addEventListener("DOMContentLoaded", function () {
    // DOMContentLoaded executado - procurando elemento bar-chart

    const barChartElement = document.getElementById("bar-chart");
    // Elemento bar-chart encontrado

    if (barChartElement) {
        // Dataset abertas e concluidas

        const abertas = JSON.parse(barChartElement.dataset.abertas);
        const concluidas = JSON.parse(barChartElement.dataset.concluidas);

        // Dados parseados - chamando renderBarChart...

        renderBarChart(abertas, concluidas);

        // renderBarChart chamado com sucesso
    } else {
        // Elemento bar-chart não encontrado!
    }
});

// Funcionalidades específicas que precisam ser mantidas globalmente

// Status loading button - funcionalidade global
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        const target = event.target;

        if (target.matches("button, input[type='submit'], a")) {
            const loadingText = target.getAttribute("data-loading-text");

            if (loadingText) {
                // Caso seja um link com href, esperar um curto tempo antes de navegar
                if (target.tagName === "A" && target.getAttribute("href")) {
                    event.preventDefault();
                    setLoadingState(target, loadingText);

                    // Redireciona após 1 segundo para dar tempo de mostrar o loading
                    setTimeout(() => {
                        window.location.href = target.getAttribute("href");
                    }, 1000);
                }
                // Caso seja um botão dentro de um formulário
                else if (target.closest("form")) {
                    const form = target.closest("form");

                    // Verifica se o formulário é válido antes de enviar
                    if (!form.checkValidity()) {
                        form.classList.add("was-validated"); // Adiciona a classe do Bootstrap para exibir mensagens
                        return; // Se não for válido, não prossegue
                    }

                    event.preventDefault(); // Evita envio imediato
                    setLoadingState(target, loadingText);

                    // Aguarda 1 segundo e envia o formulário
                    window.onbeforeunload = null; // Evita o alerta de alterações não salvas
                    setTimeout(() => {
                        form.submit();
                    }, 1000);
                }
                // Caso seja um botão normal, apenas ativa o loading
                else {
                    setLoadingState(target, loadingText);

                    // Simula carregamento e depois reseta
                    setTimeout(() => {
                        resetButtonState(target);
                    }, 3000);
                }
            }
        }
    });
});

// Exporta funções globais necessárias
window.loadServicesData = loadServicesData;
window.initServiceSelect = initServiceSelect;
window.modalPassSuccess = modalPassSuccess;
window.calculaDesconto = calculaDesconto;
window.calculaDescontoPorValor = calculaDescontoPorValor;
window.obterMarcas = obterMarcas;

// Log de inicialização
